import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.polyline.snakeanim/L.Polyline.SnakeAnim.js";
import "leaflet-polylinedecorator";
import 'leaflet-arrowheads';




const SnakeAnim = ({ startAnimation, type, positions, tme }) => {
    const markerUserPos = new L.Icon({
        iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [13, 34],
        shadowSize: [41, 41],
    });

    const greenIcon = new L.Icon({
        iconUrl:
            'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        shadowUrl:
            'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [44, 41],
        iconAnchor: [12, 41],
        popupAnchor: [11, 34],
        shadowSize: [41, 41],
    });

    const redIcon = new L.Icon({
        iconUrl:
            'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl:
            'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [44, 41],
        iconAnchor: [12, 41],
        popupAnchor: [11, 34],
        shadowSize: [41, 41],
    });
    const map = useMap();

    const clearMap = (map) => {
        map.eachLayer((layer) => {
            const hasEmptyContrib = !(layer.getAttribution && layer.getAttribution());
            const hasNoContrib = !layer.getAttribution;
            if (hasEmptyContrib || hasNoContrib) {
                map.removeLayer(layer);
            }
        })
    }

    useEffect(() => {

        if (!startAnimation) return;
        const markers = positions;
        let route = L.featureGroup();
        clearMap(map);
        const markerLenght = markers.length;

        route.addLayer(new L.Marker(markers[0], { icon: redIcon }).bindPopup(L.popup({ maxWidth: 500 }).setContent("Type:" + type[0] + "    " + " Date:" + tme[0]))).addTo(map);
        map.fitBounds(route.getBounds());
        if (markerLenght > 1) {
            const line = new L.polyline([markers[0], markers[1]]).addTo(map)
            const decorator = L.polylineDecorator(line, {
                patterns: [
                    // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                    { offset: 0, repeat: 50, symbol: L.Symbol.arrowHead({ pixelSize: 10, polygon: false, color: 'red', pathOptions: { stroke: true, color: 'red', weight: 2 } }) }
                ]
            });

            let nj = 0;
            
            route.addLayer(decorator);
            map.flyToBounds(route, { duration: 0.5 })
            if (markerLenght > 2) {
                for (let i = 1; i < markerLenght - 1; i++) {

                    setTimeout(function () {
                        const marker = new L.Marker(markers[i], { icon: markerUserPos }).bindPopup(L.popup({ maxWidth: 500 }).setContent("Type:" + type[i] + "    " + "Date:" + tme[i])).addTo(map);

                        const line = new L.polyline([markers[i], markers[i + 1]]).addTo(map);
                        const decorator = L.polylineDecorator(line, {
                            patterns: [
                                // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                                { offset: 0, repeat: 50, symbol: L.Symbol.arrowHead({ pixelSize: 10, polygon: false, color: 'red', pathOptions: { stroke: true, color: 'red', weight: 2 } }) }
                            ]
                        }).addTo(map);

                        route.addLayer(marker);
                        route.addLayer(decorator);
                        //map.fitBounds(route.getBounds());
                        map.flyToBounds(route, { duration: 2 });
                         
                    }, 5 * i)
                    nj =+ i;          
                }; 
                    
            }
     setTimeout(function() {
            if (markerLenght === 2 || nj === markerLenght - 2) {
                route.addLayer(new L.Marker(markers[markerLenght - 1], { icon: greenIcon }).bindPopup(L.popup({ maxWidth: 500 }).setContent("Type: " + type[markerLenght - 1] + "    " + "Date:" + tme[markerLenght - 1]))).addTo(map);
                const line2 = new L.polyline([markers[markerLenght - 2], markers[markerLenght - 1]]).addTo(map)
                const decorator2 = L.polylineDecorator(line2, {
                    weight: 3,
                    patterns: [
                        // defines a pattern of 10px-wide dashes, repeated every 20px on the line
                        { offset: 0, repeat: 50, symbol: L.Symbol.arrowHead({ pixelSize: 10, polygon: false, color: 'red', pathOptions: { stroke: true, color: 'red', weight: 2 } }) }
                    ]
                });
                route.addLayer(decorator2);
                map.fitBounds(route.getBounds());
            }
        }, 10*markerLenght)

        } else {
            route.addLayer(new L.Marker(markers[markerLenght - 1], { icon: greenIcon }).bindPopup(L.popup({ maxWidth: 500 }).setContent("Type:" + type[markerLenght - 1] + "      " + "Date:  " + tme[markerLenght - 1])));
            map.fitBounds(route.getBounds());

            map.addLayer(route);
        }

    

    }, [startAnimation])
    return null;
};



export default SnakeAnim;
